// extracted by mini-css-extract-plugin
module.exports = {"header":"BigHeader_header__14VHj","title":"BigHeader_title__kSGOa"};